// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TerapijeModal_modalOverlay__NWZyQ {
  position: fixed;
  top: 0;
  left: 15%;
  width: 85%;
  height: 100%;
  background-color: #000000d6;
  z-index: 100;
}
.TerapijeModal_modalOverlay__NWZyQ,
.TerapijeModal_tableWrapper__z5hrU,
.TerapijeModal_pageNumber__T5GpG,
.TerapijeModal_navigationRow__e8Jlb {
  display: flex;
  align-items: center;
  justify-content: center;
}
.TerapijeModal_infoModal__Jv6d2 {
  height: 100%;
  width: 100%;
  padding: 24px 0px 24px 0px;
  gap: 100px;
}
.TerapijeModal_infoModal__Jv6d2,
.TerapijeModal_modalWrapper__0sLaT {
  justify-content: flex-start;
  flex-direction: column;
}
.TerapijeModal_infoModal__Jv6d2,
.TerapijeModal_btnRow__JG\\+qQ,
.TerapijeModal_modalWrapper__0sLaT {
  display: flex;
  align-items: center;
}
.TerapijeModal_modalWrapper__0sLaT {
  width: 90%;
  border-radius: 16px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background-color: #ffffff;
}
.TerapijeModal_exitBtn__K8I29 {
  position: absolute;
  top: 5%;
  right: 3%;
  cursor: pointer;
}
.TerapijeModal_tableWrapper__z5hrU {
  width: 100%;
  margin-top: -48px;
}
.TerapijeModal_title__O7iS7 {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.TerapijeModal_btnRow__JG\\+qQ {
  width: 95%;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  justify-content: space-between;
}
.TerapijeModal_navigationRow__e8Jlb {
  gap: 16px;
  cursor: pointer;
}
.TerapijeModal_pageNumber__T5GpG {
  width: 40px;
  height: 40px;
  padding: 0px, 16px, 0px, 16px;
  border-radius: 5px;
  background-color: #e6e9ec;
}

@media screen and (max-width: 1300px) {
  .TerapijeModal_modalOverlay__NWZyQ {
    width: 100%;
    left: 0;
  }
  .TerapijeModal_modalWrapper__0sLaT {
    width: 80%;
    height: 80%;
    padding-bottom: 16px;
    overflow-y: scroll;
  }
  .TerapijeModal_infoModal__Jv6d2 {
    gap: 50px;
  }
  .TerapijeModal_btnRow__JG\\+qQ {
    padding-bottom: 24px;
  }
}
@media screen and (max-width: 900px) {
  .TerapijeModal_title__O7iS7 {
    padding: 0 20px;
    text-align: center;
    margin-top: 10px;
  }
  .TerapijeModal_tableWrapper__z5hrU {
    margin-top: -80px;
  }
  .TerapijeModal_modalWrapper__0sLaT {
    overflow-y: scroll;
    height: 75%;
  }
  .TerapijeModal_infoModal__Jv6d2 {
    gap: 80px;
  }
}

@media screen and (max-width: 750px) {
  .TerapijeModal_modalWrapper__0sLaT {
    position: inherit;
    left: 0%;
    width: 100%;
    max-height: 90%;
    overflow-y: scroll;
  }

  .TerapijeModal_tableWrapper__z5hrU {
    overflow-x: scroll;
    overflow-y: hidden;
  }
}
@media screen and (max-width: 400px) {
  .TerapijeModal_title__O7iS7 {
    margin-bottom: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/TerapijeModal/TerapijeModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;AACA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,UAAU;AACZ;AACA;;EAEE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 15%;\n  width: 85%;\n  height: 100%;\n  background-color: #000000d6;\n  z-index: 100;\n}\n.modalOverlay,\n.tableWrapper,\n.pageNumber,\n.navigationRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.infoModal {\n  height: 100%;\n  width: 100%;\n  padding: 24px 0px 24px 0px;\n  gap: 100px;\n}\n.infoModal,\n.modalWrapper {\n  justify-content: flex-start;\n  flex-direction: column;\n}\n.infoModal,\n.btnRow,\n.modalWrapper {\n  display: flex;\n  align-items: center;\n}\n.modalWrapper {\n  width: 90%;\n  border-radius: 16px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  background-color: #ffffff;\n}\n.exitBtn {\n  position: absolute;\n  top: 5%;\n  right: 3%;\n  cursor: pointer;\n}\n.tableWrapper {\n  width: 100%;\n  margin-top: -48px;\n}\n.title {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.btnRow {\n  width: 95%;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  justify-content: space-between;\n}\n.navigationRow {\n  gap: 16px;\n  cursor: pointer;\n}\n.pageNumber {\n  width: 40px;\n  height: 40px;\n  padding: 0px, 16px, 0px, 16px;\n  border-radius: 5px;\n  background-color: #e6e9ec;\n}\n\n@media screen and (max-width: 1300px) {\n  .modalOverlay {\n    width: 100%;\n    left: 0;\n  }\n  .modalWrapper {\n    width: 80%;\n    height: 80%;\n    padding-bottom: 16px;\n    overflow-y: scroll;\n  }\n  .infoModal {\n    gap: 50px;\n  }\n  .btnRow {\n    padding-bottom: 24px;\n  }\n}\n@media screen and (max-width: 900px) {\n  .title {\n    padding: 0 20px;\n    text-align: center;\n    margin-top: 10px;\n  }\n  .tableWrapper {\n    margin-top: -80px;\n  }\n  .modalWrapper {\n    overflow-y: scroll;\n    height: 75%;\n  }\n  .infoModal {\n    gap: 80px;\n  }\n}\n\n@media screen and (max-width: 750px) {\n  .modalWrapper {\n    position: inherit;\n    left: 0%;\n    width: 100%;\n    max-height: 90%;\n    overflow-y: scroll;\n  }\n\n  .tableWrapper {\n    overflow-x: scroll;\n    overflow-y: hidden;\n  }\n}\n@media screen and (max-width: 400px) {\n  .title {\n    margin-bottom: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `TerapijeModal_modalOverlay__NWZyQ`,
	"tableWrapper": `TerapijeModal_tableWrapper__z5hrU`,
	"pageNumber": `TerapijeModal_pageNumber__T5GpG`,
	"navigationRow": `TerapijeModal_navigationRow__e8Jlb`,
	"infoModal": `TerapijeModal_infoModal__Jv6d2`,
	"modalWrapper": `TerapijeModal_modalWrapper__0sLaT`,
	"btnRow": `TerapijeModal_btnRow__JG+qQ`,
	"exitBtn": `TerapijeModal_exitBtn__K8I29`,
	"title": `TerapijeModal_title__O7iS7`
};
export default ___CSS_LOADER_EXPORT___;
